import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default class Radio extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    e2e: PropTypes.string,
    className: PropTypes.string,
  };

  onChange = (e) => {
    this.props.onChange(this.props.value, this.props.name);
  };

  render() {
    const name = `${this.props.name}-${this.props.value}`;
    return (
      <div className={cx(styles.radio, this.props.className)}>
        <input
          id={`radio-${name}`}
          type="radio"
          value={this.props.value}
          name={name}
          checked={this.props.checked}
          onChange={this.onChange}
          data-e2e={this.props.e2e}
        />
        <label htmlFor={`radio-${name}`}>{this.props.label}</label>
      </div>
    );
  }
}
